<template>
    <div class="container">
        <el-table v-loading="tableInitStatus === 'loading'" :data="data" header-cell-class-name="header-cell-style"
            header-row-class-name="header-row-style" cell-class-name="cell-style" row-class-name="row-style"
            v-loadmore="loadMore" stripe height="100%" style="width: 100%">
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="name" label="回路名称"></el-table-column>
            <el-table-column prop="position" label="位置"></el-table-column>

            <template v-if="classify === 'TELEMETRY_OVERRUN' || classify === 'DEVICE_EXCEPTION'">
                <el-table-column prop="classify" label="事件分类" key="1">
                    <template slot-scope="scope">
                        <span>{{scope.row.classify | mapper}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="事件类型" key="2"></el-table-column>
            </template>

            <template v-else>
                <el-table-column prop="eventName" label="事件名称" key="3"></el-table-column>
            </template>

            <el-table-column prop="start" label="发生时间">
                <template slot-scope="scope">
                    <span>{{scope.row.start | dateformat}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="end" label="结束时间">
                <template slot-scope="scope">
                    <span>{{scope.row.end | dateformat}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="description" label="报警描述"></el-table-column>
            <el-table-column prop="check" label="报警确认">
                <template slot-scope="scope">
                    <span :style="scope.row.check ? 'color:#666' : 'color:red'">{{scope.row.check | status}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="operation" label="操作">
                <template slot-scope="scope">
                    <!--size="small"-->
                    <el-button @click="handleClick(scope.row, '查看')" type="text">查看</el-button>
                    <el-button @click="handleClick(scope.row, '确认')" type="text"
                        :disabled="scope.row.check ? true : false">确认</el-button>
                </template>
            </el-table-column>

            <template v-slot:empty>
                <img :src="require('../../assets/img/not_found_data.png')">
            </template>

            <template v-slot:append>
                <div class="center" v-if="loading">加载中...</div>
                <div class="center" v-if="nomore && data.length>20">到底了</div>
            </template>
        </el-table>
    </div>
</template>

<script>
    import {
        dateFormat
    } from '../../util/DateUtil';

    const TYPES = {
        TELEMETRY_OVERRUN: '越限异常',
        EQUIPMENT_FAILURE: '网关离线',
        TELEMETRY_DISPLACEMENT: '跳闸报警',
        // DEVICE_EXCEPTION: '设备异常',
         DEVICE_FAILURE: '设备异常',
    }
    export default {
        props: {
            data: Array,
            classify: String,
            loadMoreStatus: String,
            tableInitStatus: String,
        },
        directives: {
            loadmore: {
                bind: function (el, binding) {
                    const selectWarp = el.querySelector('.el-table__body-wrapper');
                    selectWarp.addEventListener('scroll', function () {
                        let sign = 100;
                        const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
                        if (scrollDistance <= sign) {
                            binding.value();
                        }
                    })
                }
            }
        },
        methods: {
            handleClick(row, value) {
                if (value == '查看') {
                    this.$emit('showDetail', row.code);
                } else if (value == '确认') {
                    this.$emit('setCheck', row.code)
                }
            },
            loadMore() {
                if (this.disabled) {
                    return;
                }
                this.$emit('loadMore');
            }
        },
        computed: {
            loading: function () {
                return this.loadMoreStatus === 'loading';
            },
            nomore: function () {
                return this.loadMoreStatus === 'noMore';
            },
            disabled: function () {
                return this.loading || this.nomore;
            }
        },
        filters: {
            dateformat: function (value) {
                if (!value) {
                    return '--';
                }
                return dateFormat('YYYY年mm月dd日 HH:MM', new Date(value));
            },
            mapper: function (value) {
                return TYPES[value] || '未知事件';
            },
            status: function (value) {
                return value ? '已确认' : '未确认'
            }
        }
    }
</script>

<style lang="less" scoped>
    .container {
        height: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        //火狐隐藏滚动条
        scrollbar-width: none;

        .center {
            text-align: center;
            line-height: 48rem;
            height: 48rem;
        }
    }
</style>